/**
 * @generated SignedSource<<2b7e1ecb8868275f59aedb834e1e5a4a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type NodeInput = {
  id: string;
};
export type HighlightsTabDeleteAlbumMutation$variables = {
  input: NodeInput;
};
export type HighlightsTabDeleteAlbumMutation$data = {
  readonly deleteHighlightAlbum: {
    readonly id: string;
  };
};
export type HighlightsTabDeleteAlbumMutation = {
  response: HighlightsTabDeleteAlbumMutation$data;
  variables: HighlightsTabDeleteAlbumMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "GraphQLHighlightAlbum",
    "kind": "LinkedField",
    "name": "deleteHighlightAlbum",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "HighlightsTabDeleteAlbumMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "HighlightsTabDeleteAlbumMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c2a80898db93f4d7d8ac946570c78413",
    "id": null,
    "metadata": {},
    "name": "HighlightsTabDeleteAlbumMutation",
    "operationKind": "mutation",
    "text": "mutation HighlightsTabDeleteAlbumMutation(\n  $input: NodeInput!\n) {\n  deleteHighlightAlbum(input: $input) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "09758308625d40bb076bdccd3c6ad882";

export default node;
